import { Container, Stack } from "@mui/material"
import { Page } from ".."
import HeaderBreadcrumbs from "../header-breadcrumbs"
import { ScheduleList } from "./scheduleList"

export const ScheduleListScreen: React.FC = () => {
    return (
        <Page title="">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Team Schedules"
                        links={[
                            {
                                name: 'View all user schedules from your subscription.',
                                href: '/schedules'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <ScheduleList/>
            </Container>
        </Page>
    )
}